import { InfoCircleFilled } from '@ant-design/icons'
import Flex from 'components/Flex'
import { Doughnut } from 'react-chartjs-2'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const OverViewText = styled.div`
  color: #343e59;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  margin-top: 35px;
  margin-left: calc(-20px);
`

export const LegendDot = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  background-color: ${props => props.color};
`
export const pieChartWidth = styled.div`
  width: 500px;
`
export const AnswerOptionBackground = styled.div`
  display: flex;
  margin-right: 8px;
  border-radius: 50%;
  padding: 4px;
  width: 15px;
  height: 15px;
`

export const AnswerDiv = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
  flex-direction: column-reverse;
  padding-bottom: 30px;
`

export const AnswerOptions = styled.div`
  display: flex;
  align-items: center;
`

export const AnswerText = styled.div`
  color: #343e59;
  font-size: 12px;
  font-weight: 300;
`

export const PieChartContainer = styled.div`
  width: 75%;
  background-color: #f5f6fd;
  margin-top: 30px;
  gap: 50px;
  display: flex;
  alignitems: center;
`
export const ScoreALign = styled.div`
  color: #343e59;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  padding-top: 15px;
`

export const Container = styled.div`
  color: #343e59;
  border: red solid 3px;
  width: 547px;
  height: 394px;
`

export const TopDiv = styled.div`
  color: #343e59;
  border: red solid 3px;
  margin-left: 60px;
  margin-top: 5px;
`

export const IndividualCardDiv = styled(Flex)`
  justify-content: left;
  background: #f5f6fd;
  padding: 5px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.5s;

  :hover {
    background-color: ${COLORS.BLUE_T_80};
  }
  width: ${props => (props.width ? '40em' : '')};
  height: 112%;
  gap: 5rem;
`

export const LegendContainer = styled.div`
  width: 17rem;
  display: flex;
`
export const ChartContainer = styled.div`
  width: 300px;
  height: 300px;
`
export const LineHeight = styled.div`
  line-height: 1rem;
  width: 110px;
  height: 50px;
  font-size: 0.6em;
  letter-spacing: 0.1em;
  border: transparent solid 2px;
  background-color: #821b61;
  border-radius: 10px;
  text-align: center;
  margin-top: 2rem;
  color: white;
  align-items: center;
  display: flex;
`
export const LineHeightLegend = styled.div`
  line-height: 1.5rem;
  color: black;
  font-size: 0.8em !important;
`
export const LineHeightLegendChart = styled.div`
  line-height: 1.7rem;
`
export const StaticData = styled.div`
  width: 15rem;
  color: #999fac;
  font-weight: 600 !important;
`
export const DynamicData = styled.div`
  width: 2rem;
  color: #343e59;
  font-weight: 600 !important;
  margin-top: 3rem;
  margin-left: 1rem;
`

export const LegendDiv = styled.div`
  color: #343e59;
  font-size: 1.1em;
  font-weight: 900;
`

export const LegendTabDiv = styled.div`
  margin-top: 2rem;
  margin-bottom: 0.5rem;
`
export const NoteMessageDiv = styled(Flex)`
  line-height: 1rem;
  width: 22.5rem;
  height: 30px;
  border: #d6dbf7 solid 2px;
  background-color: ${props => (props.mandatory ? '#3249d7' : 'white')};
  border-radius: 10px;
  justify-content: left;
  margin-left: 20px;
  margin-top: 20px;
  transition: background-color 0.3s;
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
`
export const NoteMessageDivNew = styled(Flex)`
  line-height: 1rem;
  height: 40px;
  border: #d6dbf7 solid 2px;
  background-color: ${props => (props.mandatory ? '#3249d7' : 'white')};
  border-radius: 15px;
  justify-content: left;
  margin-bottom: 20px;
  transition: background-color 0.3s;
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
  display: inline-flex;
`
export const NoteMessageSummary = styled(Flex)`
  line-height: 1rem;
  height: 40px;

  border: #d6dbf7 solid 2px;
  background-color: ${props => (props.mandatory ? '#3249d7' : 'white')};
  border-radius: 15px;
  justify-content: left;
  transition: background-color 0.3s;
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
  width: 25rem;
`
export const NoteMessageSummaryNew = styled(Flex)`
  line-height: 1rem;
  height: 40px;

  border: #d6dbf7 solid 2px;
  background-color: ${props => (props.mandatory ? '#3249d7' : 'white')};
  border-radius: 15px;
  justify-content: left;
  transition: background-color 0.3s;
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
  width: 7rem;
`

export const AlertTextDiv = styled.div`
  font-size: 0.8em;
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
  margin-left: 4px;
  font-weight: 600;
  margin-left: 4px;
  display: flex;
`
export const AlertTextDivNew = styled.div`
  font-size: 0.8em;
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
  margin-left: 4px;
  margin-right: 4px;
  font-weight: 600;
  margin-left: 4px;
  display: flex;
`
export const StyledInfoCircles = styled(InfoCircleFilled)`
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
  margin-left: 4px;

  font-size: 18px;
`
export const StyledSpaceDiv = styled.div`
  display: flex;
  gap: 4px;
  margin-left: 4px;
  align-items: center;
`

export const LegendAnswerDiv = styled.div`
  width: '105%';
  marginbottom: '0.2rem';
  color: blue;
`

export const CustomDoughnut = styled(Doughnut)`
  .chartjs-render-monitor
    .chartjs-size-monitor
    .chartjs-render-monitor
    .chartjs-size-monitor-text {
    font-size: 18px;
  }

  .chartjs-render-monitor
    .chartjs-size-monitor
    .chartjs-render-monitor
    .chartjs-size-monitor-legend {
    font-size: 12px;
  }

  .chartjs-render-monitor
    .chartjs-size-monitor
    .chartjs-render-monitor
    .chartjs-size-monitor-legend
    .chartjs-legend-0
    span {
    color: #343e59;
  }

  margin-top: 1rem;
`
